<div class="snack-bar" data-ideals="snackBarContainer">
  <i class="snack-bar__status" [ngClass]="statusIcon"></i>
  <span class="snack-bar__message">
    {{config.announcementMessage}}
  </span>
  <i class="snack-bar__close icons-cross"
     (click)="close()"
     data-ideals="snackBarContainerClose"></i>
</div>
